import RouteView from '@/layouts/RouteView'
import MenuView from '@/layouts/MenuView'

const lazyDistributor = {
  distributorRouter: [
    {
      path: '/index',
      name: '首页',
      component: MenuView,
      redirect: '/login',
      icon: 'none',
      invisible: true,
      children: [
        {
          path: '/dashboard',
          name: '首页',
          component: RouteView,
          icon: 'home',
          children: [
            {
              path: '/dashboard/Analysis',
              name: '首页',
              component: () => import('@/pages/dashboard/Analysis'),
              icon: 'none'
            },
            {
              path: '/dashboard/BasicAccountingInformation',
              name: '账务基础信息',
              component: () => import('@/pages/dashboard/BasicAccountingInformation'),
              invisible: true,
              icon: 'none'
            },
            {
              path: '/dashboard/NoticeInfo',
              name: '公告信息',
              component: () => import('@/pages/dashboard/NoticeInfo'),
              invisible: true,
              icon: 'none'
            },
            {
              path: '/dashboard/TodayOrderDetails',
              name: '今日订购信息',
              component: () => import('@/pages/dashboard/TodayOrderDetails'),
              invisible: true,
              icon: 'none'
            },
            {
              path: '/dashboard/DetailsTodayOrder',
              name: '今日订购详情',
              component: () => import('@/pages/dashboard/DetailsTodayOrder'),
              invisible: true,
              icon: 'none'
            },
            {
              path: '/dashboard/MonthOrderDetails',
              name: '本月订购信息',
              component: () => import('@/pages/dashboard/MonthOrderDetails'),
              invisible: true,
              icon: 'none'
            },
          ]
        },
        {
          path: '/enterprise',
          name: '企业管理',
          icon: 'bank',
          component: RouteView,
          children: [
            {
              path: '/enterprise/Basic',
              name: '基本信息',
              icon: 'none',
              component: () => import('@/pages/enterprise/Basic')
            },
            {
              path: '/enterprise/Contracts',
              name: '合同信息',
              icon: 'none',
              component: () => import('@/pages/enterprise/Contracts')
            }
          ]
        },
        {
          path: '/order',
          name: '订购管理',
          icon: 'pay-circle',
          component: RouteView,
          children: [
            {
              path: '/order/OrderWayInfo',
              name: '交付方式',
              icon: 'none',
              component: () => import('@/pages/order/OrderWayInfo')
            },
            {
              path: '/order/OrderWayProduct',
              name: '交付产品',
              icon: 'none',
              component: () => import('@/pages/order/OrderWayProduct')
            },
            {
              path: '/order/OrderOrdinary',
              name: '普通订购',
              icon: 'none',
              component: () => import('@/pages/order/OrderOrdinary')
            }, {
              path: '/order/BulkImport',
              name: '批量订购',
              icon: 'none',
              component: () => import('@/pages/order/BulkImport')
            }
          ]
        },
        {
          path: '/accounts',
          name: '财务管理',
          icon: 'calculator',
          component: RouteView,
          children: [
            {
              path: '/accounts/ChannelCharges',
              name: '交易明细',
              icon: 'none',
              component: () => import('@/pages/accounts/ChannelCharges')
            },
            {
              path: '/accounts/DayBill',
              name: '日账单',
              icon: 'none',
              component: () => import('@/pages/accounts/DayBill')
            },
            {
              path: '/accounts/MonthBill',
              name: '月账单',
              icon: 'none',
              component: () => import('@/pages/accounts/MonthBill')
            },
          ]
        },
        {
          path: '/OrderQuery',
          name: '订购查询',
          icon: 'profile',
          component: RouteView,
          children: [
            {
              path: '/OrderQuery/APIOrderQuery',
              name: 'API订购查询',
              icon: 'none',
              component: () => import('@/pages/OrderQuery/APIOrderQuery')
            },
            {
              path: '/OrderQuery/OnlineOrderQuery',
              name: '在线订购查询',
              icon: 'none',
              component: () => import('@/pages/OrderQuery/OnlineOrderQuery')
            },
            {
              path: '/OrderQuery/DoOrderInfo',
              name: '文件订购详情',
              icon: 'none',
              invisible: true,
              component: () => import('@/pages/OrderQuery/DoOrderInfo')
            },
          ]
        },
        {
          path: '/Console',
          name: '我的控制台',
          icon: 'profile',
          component: RouteView,
          children: [
            {
              path: '/Console/BusinessApply',
              name: '业务申请',
              icon: 'none',
              component: () => import('@/pages/Console/BusinessApply'),
            },
            {
              path: '/Console/MyTask',
              name: '我的任务',
              icon: 'none',
              component: () => import('@/pages/Console/MyTask'),
            },

            {
              path: '/Console/Detail:parameter',
              name: '详情',
              icon: 'none',
              component: () => import('@/pages/Console/Detail'),
              invisible: true,
            },
            {
              path: '/Console/ProcessInstance',
              name: '流程实例',
              icon: 'none',
              component: () => import('@/pages/Console/ProcessInstance'),
            },
          ],
        },
      ],
    },
  ],
};

export default lazyDistributor






// WEBPACK FOOTER //
// ./src/router/lazyDistributor.js